import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const IntegrationSection = ({ 
  formData, 
  errors, 
  onChange,
  onTestConnection 
}) => {
  const [isTesting, setIsTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const handleTestConnection = async () => {
    setIsTesting(true);
    setTimeout(() => {
      setTestResult({
        success: true,
        message: 'Подключение успешно установлено'
      });
      setIsTesting(false);
    }, 2000);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
          Интеграции
        </h3>
        <p className="text-sm text-text-secondary mb-6">
          Подключение внешних сервисов и виджетов
        </p>
      </div>
      <div className="bg-muted p-4 md:p-6 rounded-lg space-y-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary flex items-center justify-center">
            <Icon name="Calendar" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h4 className="text-base md:text-lg font-semibold text-foreground">
              Аренда Вместе
            </h4>
            <p className="text-xs md:text-sm text-text-secondary">
              Виджеты бронирования помещений
            </p>
          </div>
        </div>

        <Input
          label="ID локации по умолчанию"
          type="text"
          name="defaultLocationId"
          placeholder="location_12345"
          value={formData?.defaultLocationId}
          onChange={onChange}
          error={errors?.defaultLocationId}
          description="Используется для виджетов бронирования"
          className="mb-4"
        />

        <Input
          label="API ключ"
          type="password"
          name="bookingApiKey"
          placeholder="••••••••••••••••"
          value={formData?.bookingApiKey}
          onChange={onChange}
          error={errors?.bookingApiKey}
          description="Получите ключ в личном кабинете Аренда Вместе"
          className="mb-4"
        />

        <Checkbox
          label="Включить виджет бронирования"
          checked={formData?.enableBookingWidget}
          onChange={(e) => onChange({ 
            target: { name: 'enableBookingWidget', value: e?.target?.checked } 
          })}
          description="Показывать виджет на всех страницах сайта"
        />

        <Button
          variant="outline"
          iconName="Zap"
          iconPosition="left"
          onClick={handleTestConnection}
          loading={isTesting}
          disabled={!formData?.bookingApiKey}
          className="mt-4"
        >
          Проверить подключение
        </Button>

        {testResult && (
          <div className={`flex items-start gap-3 p-3 rounded-lg ${
            testResult?.success ? 'bg-success/10' : 'bg-error/10'
          }`}>
            <Icon 
              name={testResult?.success ? 'CheckCircle' : 'XCircle'} 
              size={20} 
              className={testResult?.success ? 'text-success' : 'text-error'}
            />
            <p className="text-sm">{testResult?.message}</p>
          </div>
        )}
      </div>
      <div className="border-t border-border pt-6">
        <h4 className="text-base md:text-lg font-semibold text-foreground mb-4">
          Google Analytics
        </h4>

        <Input
          label="ID отслеживания"
          type="text"
          name="googleAnalyticsId"
          placeholder="G-XXXXXXXXXX"
          value={formData?.googleAnalyticsId}
          onChange={onChange}
          error={errors?.googleAnalyticsId}
          description="Формат: G-XXXXXXXXXX или UA-XXXXXXXXX-X"
          className="mb-4"
        />

        <Checkbox
          label="Включить отслеживание"
          checked={formData?.enableAnalytics}
          onChange={(e) => onChange({ 
            target: { name: 'enableAnalytics', value: e?.target?.checked } 
          })}
          description="Собирать статистику посещений сайта"
        />
      </div>
      <div className="border-t border-border pt-6">
        <h4 className="text-base md:text-lg font-semibold text-foreground mb-4">
          Яндекс.Метрика
        </h4>

        <Input
          label="Номер счетчика"
          type="text"
          name="yandexMetrikaId"
          placeholder="12345678"
          value={formData?.yandexMetrikaId}
          onChange={onChange}
          error={errors?.yandexMetrikaId}
          description="Найдите в настройках счетчика Яндекс.Метрики"
          className="mb-4"
        />

        <Checkbox
          label="Включить Яндекс.Метрику"
          checked={formData?.enableYandexMetrika}
          onChange={(e) => onChange({ 
            target: { name: 'enableYandexMetrika', value: e?.target?.checked } 
          })}
          description="Анализ поведения посетителей"
        />
      </div>
    </div>
  );
};

export default IntegrationSection;